<template>
  <v-text-field
    v-model="input"
    :rules="requiredRule"
    :label="customField.label + (required ? ' *' : '')"
    :hint="customField.hint"
    :placeholder="customField.placeholder"
    :disabled="disabled"
    :loading="loading"
    outlined
    persistent-hint
  >
  </v-text-field>
</template>

<style></style>

<script lang="ts">
import { requiredRule } from "@/lib/rules/requiredRule";
import { CustomFieldCreateDtoHelper } from "@/store/modules/custom-field.store";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class CustomFieldText extends Vue {
  @Prop()
  value!: string | string[];

  @Prop()
  customField!: CustomFieldCreateDtoHelper;

  @Prop()
  required!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  loading?: boolean;

  get requiredRule() {
    if (this.required) {
      return [requiredRule()];
    }
    return [];
  }

  get input(): string | string[] {
    return this.value;
  }

  set input(v: string | string[]) {
    this.$emit("input", v);
  }
}
</script>
